<template>
    <div class="billOperationRecord public_Spacing phase-panel phase-customer-panel">
        <div class="pulbic_oparetionBlock phase-filter-card">
            <div class="phase-section-head">
                <div>
                    <div class="phase-section-title">筛选条件</div>
                    <div class="phase-section-desc">按客户和时间范围筛选阶段统计数据</div>
                </div>
            </div>
            <div class="public_operatArea phase-filter-row">
                <span class="pulic_operatArea_now pulic_cursor phase-date-tab" :class="dateNowDayActive ? 'public_dateActive' : ''"
                    @click="getNowDay">当日</span>
                <span class="public_operatArea_yesterday customerOptionsy pulic_cursor phase-date-tab"
                    :class="dateYesterdayActive ? 'public_dateActive' : ''" @click="getYesterday">昨天</span>
                <span class="pulic_operatArea_now pulic_cursor phase-date-tab" :class="dateNowMonthActive ? 'public_dateActive' : ''"
                    @click="sameMonth">当月</span>
                <span class="public_operatArea_yesterday pulic_cursor phase-date-tab"
                    :class="dateLastMonthActive ? 'public_dateActive' : ''" @click="lastMonth">上月</span>
                <div class="public_operatArea_timePicker pulic_cursor phase-date-picker">
                    <el-date-picker v-model="date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
                        :picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日"
                        end-placeholder="结束日" class="pulic_cursor">
                    </el-date-picker>
                </div>
                <div class="public_oparetionBlock_Menu phase-field">
                    <label class="public_lbSty">客户：</label>
                    <el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择"
                        :clearable="true" filterable remote :remote-method="filterCustomer">
                        <el-option v-for="(item, index) in filteredCustomerOptions" :key="index" :label="item.ORMTB410CA00"
                            :value="item.ORMTB410ID">
                        </el-option>
                    </el-select>
                </div>
                <div class="public_operatBtn phase-filter-actions">
                    <el-button type="primary" @click="queryClick">查询</el-button>
                </div>
            </div>
        </div>
        <div class="staticTotalAmount phase-summary-grid">
            <div class="content_box phase-summary-card phase-summary-card-profit">
                <div class="phase-summary-label">总盈亏</div>
                <div class="phase-summary-value">{{ sum.sumProfit }}</div>
            </div>
            <div class="content_box phase-summary-card">
                <div class="phase-summary-label">总毛利</div>
                <div class="phase-summary-value">{{ sum.sumMargin }}</div>
            </div>
            <div class="content_box phase-summary-card">
                <div class="phase-summary-label">预估总服务费</div>
                <div class="phase-summary-value">{{ sum.sumSETTB425CA06 }}</div>
            </div>
            <div class="content_box phase-summary-card">
                <div class="phase-summary-label">实收总服务费</div>
                <div class="phase-summary-value">{{ sum.sumShiShou}}</div>
            </div>
            <div class="content_box phase-summary-card">
                <div class="phase-summary-label">总优惠券</div>
                <div class="phase-summary-value">{{ sum.sumDiscount }}</div>
            </div>
            <div class="content_box phase-summary-card">
                <div class="phase-summary-label">总运费</div>
                <div class="phase-summary-value">{{ sum.sumFreight }}</div>
            </div>
         </div>
        <div class="billOperationRecord-table pulbic_table_container phase-table-card">
            <div class="phase-table-head">
                <div class="phase-section-title">客户阶段明细</div>
                <div class="phase-section-desc">共 {{ pagingPageMo }} 条记录，展示客户维度销售和盈亏明细</div>
            </div>
            <el-table tooltip-effect="dark" :data="tableData" style="width: 100%;" max-height="90%"
                :default-sort="{ prop: 'waterNum', order: 'descending' }" :header-cell-style="{
                    color: 'rgba(51,51,51,1)',
                    'font-weight': 'bold',
                }" class="public_tableColumn">
                <el-table-column prop="SETTB425CA16" label="客户"></el-table-column>
                <el-table-column prop="SETTB425CA04" label="销售总额"></el-table-column>
                <el-table-column prop="SETTB425CA05" label="购进总额"> </el-table-column>
                <el-table-column prop="margin" label="毛利"></el-table-column>
                <el-table-column prop="SETTB425CA06" label="预估服务费"></el-table-column>
                <el-table-column prop="charge" label="实收服务费"></el-table-column>
                <el-table-column prop="SETTB425CA10" label="优惠券"> </el-table-column>
                <el-table-column prop="SETTB425CA04Two" label="总运费"></el-table-column>
                <el-table-column prop="SETTB425CA05Two" label="运费成本"></el-table-column>
                <el-table-column prop="SETTB425CA06Two" label="预估运费服务费"></el-table-column>
                <el-table-column prop="charge2" label="实收运费服务费"> </el-table-column>
                <el-table-column prop="profit" label="盈亏">
                    <template slot-scope="scope">
                        <div :class="scope.row.profit > 0 ? 'grennColor' : 'redColor'">{{ scope.row.profit }}</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pulbic_pagesize">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
                    layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
export default {
  mixins: [customerSearchMixin],
    name: 'CustomerPhase',
    data() {
        return {
            date: [], //日期
            dateNowDayActive: false,
            dateYesterdayActive: false,
            dateNowMonthActive: false,
            dateLastMonthActive: false,
            tableData: [],
            customerOptions: [],
            customerMo: '', //客户--查询
            pageMo: 1, //默认列表页码
            limitMo: 10, //每页的条数
            pagingPageMo: 0, //分页--数据列表共有的条数
            currentPage: 1, //设置当前页默认为1
            // 时间限制
            // 限制开始日期不能超过当前日期
            startDateDisabled: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
            },
            sum:{
                sumDiscount:0,
                sumFreight:5,
                sumMargin:0,
                sumProfit:0,
                sumSETTB425CA06:0
            },
            userobj:{}
        }
    },
    created() {
        this.userobj = this.$store.state.uobj
        this.enterprise0ptions()
        this.getNowDay()
    },
    mounted() {
        this.pageList()
    },
    methods: {
        enterprise0ptions() {
            var List = [
                {
                    ORMTB410ID: '',
                    ORMTB410CA00: '全部',
                },
            ]
            var data = {}
            if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
                data = {
                    ORMTB400ID: this.userobj.ormtb410.ORMTB410ID, //一级企业id
                }
            }
            if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
                data = {
                    ORMTB400ID: this.userobj.ormtb400.ORMTB400ID, //一级企业id
                }
            }
            var url = '/orm/ormtb420/selectOrmtb410CA00List'
            this.axios.post(url,data).then(res => {
                if (res.data.code == 200) {
                    this.customerOptions = [...List, ...res.data.data]
                    this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
                    this.customerOptionsAll = res.data.data
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        // 查询
        queryClick() {
            this.pageList()
        },
        // 列表
        pageList() {
            let loading = this.$loading({
                lock: true,
                text: '请求中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)',
            })
            const postData = {
                type:1,
                ORMTB410ID: this.customerMo,
                page: this.pageMo,
                limit: this.limitMo,
                startTime: `${this.date[0]} 00:00:00`,
                endTime: `${this.date[1]} 23:59:59`,
            }

            this.tableData = []
            const url = '/ormtb807/queryList'
            this.axios
                .post(url, postData)
                .then(res => {
                    if (res.data.code == 200) {
                        var data = res.data.data.data
                        this.tableData = data
                        this.pagingPageMo = res.data.count
                        this.sum = res.data.data.sum
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                        })
                    }
                    loading.close()
                })
                .catch(() => {
                    loading.close()
                })
        },
        //获取当前时间
        getNowDay() {
            var date = new Date().getTime()
            var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(date))
            this.date = [nowDay, nowDay]
            this.dateNowDayActive = true
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        //获取昨天时间
        getYesterday() {
            var hms = new Date().getTime() - 86400000
            var nowDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
            this.date = [nowDay, nowDay]
            this.dateNowDayActive = false
            this.dateYesterdayActive = true
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false
        },
        //获取当月时间
        sameMonth() {
            var date = new Date()
            var hms = date.setDate(1)
            var firstDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(hms))
            var nextdate = new Date().getTime()
            var nextDay = this.$baseAPI.dateFtt('yyyy-MM-dd', new Date(nextdate))
            this.date = [firstDay, nextDay]
            this.startTime = this.date[0]
            this.endTime = this.date[1]
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = true
            this.dateLastMonthActive = false
        },
        //获取上月时间
        lastMonth() {
            var nowdays = new Date()
            var year = nowdays.getFullYear()
            var month = nowdays.getMonth()
            if (month == 0) {
                month = 12
                year = year - 1
            }
            if (month < 10) {
                month = '0' + month
            }
            var firstDayOfPreMonth = year + '-' + month + '-' + '01'
            var lastDay = new Date(year, month, 0)
            let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
            this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = true
        },
        handleSizeChange(val) {
            this.pageMo = 1
            this.limitMo = val
            this.pageList()
        },
        // 点击页码
        handleCurrentChange(val) {
            this.pageMo = val
            this.pageList()
        },
        datePickerChange(e) {
            // 先重置所有状态
            this.dateNowDayActive = false
            this.dateYesterdayActive = false
            this.dateNowMonthActive = false
            this.dateLastMonthActive = false

            if (e && e.length === 2) {
                const [startDate, endDate] = e
                const start = new Date(startDate)
                const end = new Date(endDate)

                // 判断是否为当日
                const today = new Date()
                const todayStr = this.formatDate(today)
                if (startDate === todayStr && endDate === todayStr) {
                    this.dateNowDayActive = true
                    return
                }

                // 判断是否为昨日
                const yesterday = new Date(today)
                yesterday.setDate(yesterday.getDate() - 1)
                const yesterdayStr = this.formatDate(yesterday)
                if (startDate === yesterdayStr && endDate === yesterdayStr) {
                    this.dateYesterdayActive = true
                    return
                }

                // 判断是否为当月
                const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1)
                const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                const currentMonthStartStr = this.formatDate(currentMonthStart)
                const currentMonthEndStr = this.formatDate(currentMonthEnd)
                if (startDate === currentMonthStartStr && endDate === currentMonthEndStr) {
                    this.dateNowMonthActive = true
                    return
                }

                // 判断是否为上月
                const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1)
                const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0) // 当月第0天就是上个月最后一天
                const lastMonthStartStr = this.formatDate(lastMonthStart)
                const lastMonthEndStr = this.formatDate(lastMonthEnd)
                if (startDate === lastMonthStartStr && endDate === lastMonthEndStr) {
                    this.dateLastMonthActive = true
                    return
                }
            }
        },

        // 添加一个格式化日期的方法，确保格式一致
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        }
    },
}
</script>

<style scoped>

.DWD-li {
    display: flex;
    height: 35px;
    line-height: 35px;
    box-sizing: border-box;
    border: 1px solid #999;
    font-size: 16px;
    color: #333;
}

.DWD-li>div {
    padding: 0 5px;
    height: 34px;
    overflow: hidden;
    box-sizing: border-box;
}

.DWD-li-title {
    width: 150px;
    text-align: center;
    border-right: 1px solid #999;
    background-color: rgba(0, 163, 255, 0.1);
}

.right_btn {
    float: right;
    margin-bottom: 10px;
}

.DWD-li-text {
    flex: 1;
}

.DWD-li-text input {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border: none;
    outline: none;
}

.DWD-li+.DWD-li {
    border-top: none;
}

.DWD-table {
    display: flex;
}

.DWD-table-left-flex {
    flex: 1;
}

.DWD-table>div>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    text-align: center;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    box-sizing: border-box;
}

.DWD-table>div>div:first-child {
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
    width: 101px;
    text-align: center;
    background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
    padding: 0 5px;
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #999;
    border-bottom: 1px solid #999;
}

.DetailsWater-img {
    margin-top: 30px;
}

.DetailsWater-img-text {
    display: inline-block;
    width: 101px;
    text-align: center;
    vertical-align: top;
}

.car-number-add {
    /* text-transform: uppercase; */
}

.billOperationRecord-table {
    padding: 30px 0;
    box-sizing: border-box;
}

.public_singleMenu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
    background-color: #ccc;
}

.billOperationRecord .systemCodePC-add-code-table-li-ipt {
    flex: 1.5;
}

.fontBlue {
    color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
    margin-top: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
    height: 45px;
    align-items: center;
    margin-left: 20px;
}

.billOperationRecord {
    background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
    text-align: center !important;
}

.pulbic_oparetionBlock {
    padding: 0 !important;
    margin-bottom: 0 !important;
}

.public_lbSty {
    width: auto !important;
}
.staticTotalAmount {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
}
.content_box {
    width: 16%;
    padding: 25px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    text-align: center;
    color: rgb(235, 170, 122);
    font-size: 16px;
}
.grennColor {
    color: green;
}

.redColor {
    color: red;
}

.phase-panel {
    padding: 0;
    background: transparent;
}

.phase-filter-card,
.phase-table-card {
    position: relative;
    border: 1px solid rgba(217, 231, 243, .96);
    border-radius: 16px;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 8px 24px rgba(31, 93, 154, .08);
    overflow: hidden;
}

.phase-filter-card {
    margin-bottom: 14px !important;
    padding: 16px 18px !important;
}

.phase-filter-card::after,
.phase-table-card::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    content: '';
    background: linear-gradient(90deg, #2689e8, #69c0ff, rgba(105, 192, 255, 0));
}

.phase-section-head,
.phase-table-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 14px;
    padding-top: 8px;
}

.phase-section-title {
    position: relative;
    padding-left: 12px;
    color: #183b5b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.2;
}

.phase-section-title::before {
    position: absolute;
    top: 2px;
    bottom: 2px;
    left: 0;
    width: 4px;
    border-radius: 4px;
    content: '';
    background: #2689e8;
}

.phase-section-desc {
    color: #7b8fa6;
    font-size: 13px;
    line-height: 18px;
}

.phase-table-head .phase-section-desc {
    padding-right: 12px;
}

.phase-filter-row {
    display: flex !important;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    min-width: 0;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
}

.phase-date-tab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 58px;
    height: 36px !important;
    padding: 0 14px;
    border: 1px solid #d9e7f3;
    border-radius: 18px;
    background: #f8fbff;
    color: #51687f;
    font-weight: 700;
    line-height: 36px !important;
    box-sizing: border-box;
}

.phase-date-tab:hover {
    border-color: #9fd0ff;
    background: #edf7ff;
    color: #2689e8;
}

.phase-filter-row .public_dateActive {
    border-color: #2689e8;
    background: linear-gradient(135deg, #2689e8, #45a7ff) !important;
    color: #fff !important;
    box-shadow: 0 6px 14px rgba(38, 137, 232, .22);
}

.phase-date-picker,
.phase-field {
    display: inline-flex !important;
    align-items: center !important;
    height: 36px !important;
    margin: 0 !important;
}

.phase-date-picker /deep/ .el-date-editor,
.phase-field /deep/ .el-input__inner {
    height: 36px !important;
    border-color: #d9e7f3;
    border-radius: 18px;
    background: #f8fbff;
    line-height: 36px !important;
}

.phase-date-picker /deep/ .el-range__icon,
.phase-date-picker /deep/ .el-range__close-icon {
    line-height: 30px;
}

.phase-field .public_lbSty {
    display: inline-flex;
    align-items: center;
    height: 36px;
    color: #51687f;
    font-weight: 700;
    line-height: 36px;
}

.phase-field /deep/ .el-select {
    width: 190px;
}

.phase-filter-actions {
    display: inline-flex !important;
    align-items: center;
    height: 36px !important;
    margin: 0 0 0 auto !important;
    padding: 0 !important;
}

.phase-filter-actions /deep/ .el-button {
    min-width: 82px;
    height: 36px;
    padding: 0 20px;
    border: none;
    border-radius: 18px;
    background: linear-gradient(135deg, #2689e8, #45a7ff);
    font-weight: 700;
    box-shadow: 0 6px 14px rgba(38, 137, 232, .24);
}

.phase-summary-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 14px;
    background: transparent;
}

.phase-summary-card {
    position: relative;
    width: auto;
    min-height: 86px;
    padding: 16px 18px;
    border: 1px solid #e3edf7;
    border-radius: 14px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
    box-shadow: 0 6px 16px rgba(31, 93, 154, .06);
    text-align: left;
    overflow: hidden;
}

.phase-summary-card::after {
    position: absolute;
    right: -18px;
    bottom: -26px;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    content: '';
    background: rgba(38, 137, 232, .08);
}

.phase-summary-card-profit {
    background: linear-gradient(135deg, #fff8f2, #ffffff);
}

.phase-summary-label {
    color: #7b8fa6;
    font-size: 13px;
    font-weight: 700;
    line-height: 18px;
}

.phase-summary-value {
    position: relative;
    z-index: 1;
    margin-top: 10px;
    color: #e28a43;
    font-size: 22px;
    font-weight: 900;
    line-height: 1.1;
    word-break: break-all;
}

.phase-table-card {
    padding: 16px 18px 20px;
    overflow: visible;
}

.phase-table-card /deep/ .el-table {
    overflow: hidden;
    border: 1px solid #e3edf7;
    border-radius: 12px;
}

.phase-table-card /deep/ .el-table th {
    background: #f3f8fd !important;
    color: #183b5b !important;
}

.phase-table-card /deep/ .el-table__row:hover > td {
    background: #f8fbff !important;
}

.phase-table-card .pulbic_pagesize {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: flex-end;
    padding-top: 14px;
    overflow: visible;
}

@media (max-width: 1400px) {
    .phase-summary-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 1180px) {
    .phase-filter-actions {
        margin-left: 0 !important;
    }

    .phase-summary-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
